import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@swyftx/aviary/atoms/Card';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Heading, Body } from '@swyftx/aviary/atoms/Typography';

interface InfoCardProps {
  pageName: string;
  icons: Array<JSX.Element>;
}

const InfoCard: React.FC<InfoCardProps> = ({ pageName, icons }) => {
  const { t } = useTranslation('loans');
  const quantity = icons.length;

  const cardIds = Array.from({ length: quantity }, (_, i) => i + 1);
  const cardData = cardIds.map((id) => ({
    id,
    title: `${pageName}.Card${id}.title` as const,
    description: `${pageName}.Card${id}.description` as const,
    icon: icons[id - 1],
  }));

  const cards = cardData.map((card) => (
    <Card key={card.id} className='flex-1 rounded-16 p-24'>
      <FlexLayout className='flex-start flex-row gap-[24px] sm:flex-col'>
        {card.icon}
        <FlexLayout className='flex-col' spacing={12}>
          <Heading color='primary' size='h5'>
            {t(card.title as unknown as TemplateStringsArray)}
          </Heading>
          <Body size='medium' color='secondary'>
            {t(card.description as unknown as TemplateStringsArray)}
          </Body>
        </FlexLayout>
      </FlexLayout>
    </Card>
  ));

  return (
    <FlexLayout className='w-full flex-col items-stretch sm:flex-row' spacing={16}>
      {cards}
    </FlexLayout>
  );
};
InfoCard.displayName = 'InfoCard';

export { InfoCard };
